const CURRENCY_SYMBOLS = {
  USD: '$', EUR: '€', GBP: '£', JPY: '¥', CNY: '¥', INR: '₹',
  BRL: 'R$', MXN: '$', CAD: '$', AUD: '$', NZD: '$', CHF: 'Fr',
  SGD: '$', HKD: '$', KRW: '₩', THB: '฿', MYR: 'RM', IDR: 'Rp',
  PHP: '₱', VND: '₫', ZAR: 'R', TRY: '₺', RUB: '₽', PLN: 'zł',
  CZK: 'Kč', HUF: 'Ft', RON: 'lei', BGN: 'лв', HRK: 'kn',
  SEK: 'kr', NOK: 'kr', DKK: 'kr', ILS: '₪', AED: 'د.إ',
  SAR: '﷼', ARS: '$', CLP: '$', COP: '$', PEN: 'S/', UYU: '$U',
  EGP: '£', NGN: '₦',
};

export function getCurrencySymbol(code) {
  return CURRENCY_SYMBOLS[code] || "$";
}
